import React, { useState, useRef } from 'react'
import { useHistory } from "react-router"

import Menu from '@mui/material/Menu'

//images
import menuIcon from '../../../../../assets/img/icons/table-menu.png'
import deleteIcon from '../../../../../assets/img/icons/delete.svg'
import previewIcon from '@/assets/img/reservations/icons/preview.svg'

import { trans } from '../../../../../_providers/Translation'

function DeviceOptions(props) {
    const history = useHistory()

    const [table, setTable] = useState({
        options: null
    })

    const handleTableMenu = e => {

        setTable(table => {
            return {
                ...table,
                options: e.currentTarget
            }
        })
    }

    const handleCloseMenu = () => {
        setTable(table => {
            return {
                ...table,
                options: null
            }
        })
    }

    const handleDelete = () => {
        props.handleDeleteDevice(props.id)
        handleCloseMenu()
    }


    return (
        <>
            <img src={menuIcon} alt="menu" className="menu" onClick={handleTableMenu} />
            <Menu
                anchorEl={table.options}
                keepMounted
                open={Boolean(table.options)}
                onClose={handleCloseMenu}
            >
                <div onClick={() => {
                    history.push(`/parts/appliances?page=1&stock=appliances&name=${props.number}`)
                }} className="menu-option">
                    <img src={previewIcon} alt="preview" />
                    Преглед в склада
                </div>
                {props.deletable
                    ?
                    <div
                        className="menu-option"
                        onClick={handleDelete}
                        style={{
                            color: "#EC5252"
                        }}
                    >
                        <img src={deleteIcon} alt="delete" />
                        {trans('buttons.delete')}
                    </div>
                    :
                    ''
                }

            </Menu>
        </>
    )
}

export default DeviceOptions
